import React from 'react'
import { MdOutlinePlace } from "react-icons/md";
import { FaStamp } from 'react-icons/fa';
import { parseISO, format } from "date-fns";
import { getDescricaoByCod } from "../../enums/TiposGestao";


export default function MinorRequestDetails({ request, divBoleto, divContato, divRecebido, localizacaoEquip, carimboDespacho, isGestao }) {
  const equipmentRows = (request?.equipamentos && request?.equipamentos.length > 0)
    ? request.equipamentos
    : request
    ? [{
        _id: request._id,
        codSap: request.codSap,
        nomeEquipamento: request.nomeEquipamento,
        partNumberEquipamento: request.partNumberEquipamento,
        fabricanteEquipamento: request.fabricanteEquipamento,
        quantidade: request.quantidadeSolicitada,
      }]
    : [];

  return (
    <div className="flex flex-col gap-2 mt-2 mx-2 text-[11px]">
      {/* <button onClick={() => console.log(request)} >LOG</button> */}
      {/* DIV Usuario */}
      <div className="flex flex-col gap-2 py-2 px-4 bg-gray-50 border rounded-md relative">
        {/* <div className="absolute right-4 top-2 text-blue-400 font-bold">
          <a href="#">Ver mais</a>
        </div> */}

        <div className="flex flex-row gap-8 w-full">
          <div className="flex items-start gap-1 w-1/2">
            <label className="block text-gray-700 font-bold whitespace-nowrap">
              Nome Solicitante:
            </label>
            <div>{request?.nomeSolicitante}</div>
          </div>
          <div className="flex items-start gap-1  w-full">
            <label className="block text-gray-700 font-bold whitespace-nowrap">
              RE/Legal Solicitante:
            </label>
            <div>
              {request?.reLegalSolicitante}
            </div>
          </div>
        </div>
        <div className="flex flex-row gap-8 w-full">
          <div className="flex items-start gap-1  w-1/2">
            <label className="block text-gray-700 font-bold">
              UF:
            </label>
            <div>{request?.uf}</div>
          </div>
          <div className="flex items-start gap-1 w-full">
            <label className="block text-gray-700 font-bold whitespace-nowrap">
              Empresa:
            </label>
            <div>{request?.empresaSolicitante}</div>
          </div>
          <div className="flex items-start gap-1 w-full">
            <label className="block text-gray-700 font-bold whitespace-nowrap">
              Contato:
            </label>
            <div>{request?.telefone}</div>
          </div>
        </div>
      </div>

      {/* DIV Equipamento */}
      <div className="flex gap-2 py-2 px-4 bg-gray-50 border rounded-md relative">
        <div className="flex flex-col flex-1 min-w-0 gap-2">
          <div className="overflow-hidden rounded-md border border-zinc-300 bg-white shadow-sm">
            <table className="min-w-full text-[10px] text-left text-gray-700">
              <thead className="bg-gray-200">
                <tr>
                  <th colSpan="4" className="px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.12em] text-gray-600 bg-zinc-100 border-b border-zinc-300">
                    Equipamentos
                  </th>
                </tr>
                <tr>
                  <th className="px-2 py-1">Cod. Sap</th>
                  <th className="px-2 py-1">Nome</th>
                  <th className="px-2 py-1">Part Number</th>
                  <th className="px-2 py-1">Fabricante</th>
                </tr>
              </thead>
              <tbody>
                {equipmentRows.map((equipment) => (
                  <tr key={equipment._id || `${equipment.codSap}-${equipment.partNumberEquipamento}`} className="border-t border-zinc-200 align-top">
                    <td className="px-2 py-1 whitespace-nowrap">{equipment.codSap}</td>
                    <td className="px-2 py-1 whitespace-normal">{equipment.nomeEquipamento}</td>
                    <td className="px-2 py-1 whitespace-nowrap">{equipment.partNumberEquipamento}</td>
                    <td className="px-2 py-1 whitespace-nowrap">{equipment.fabricanteEquipamento}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {request?.codSapAlternativo &&
            <div className="flex items-start gap-1 text-blue-500">
              <label className="block font-bold whitespace-nowrap">
                *atendendo com SAP alternativo:
              </label>
              <div>{request?.codSapAlternativo}</div>
            </div>
          }

          {localizacaoEquip &&
            <div className="flex gap-6 w-full">
              <div className="flex items-center w-full gap-1 border border-gray-700 rounded-full px-1">
                <div className="flex items-center">
                  <MdOutlinePlace size={14} />
                  <label className="block text-gray-700 font-bold">
                    LOCALIZAÇÃO:
                  </label>
                </div>
                <div>{request?.localizacaoPrateleira}</div>
              </div>
            </div>
          }
        </div>

        <div className="flex flex-col w-[290px] shrink-0">
          <div className="overflow-hidden rounded-md border border-zinc-300 bg-white shadow-sm">
            <table className="min-w-full text-[10px] text-left text-gray-700">
              <thead className="bg-gray-200">
                <tr>
                  <th colSpan="2" className="px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.12em] text-gray-600 bg-zinc-100 border-b border-zinc-300">
                    Quantidades
                  </th>
                </tr>
                <tr>
                  <th className="px-2 py-1">Metrica</th>
                  <th className="px-2 py-1 text-center">Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-t border-zinc-200 align-middle">
                  <td className="px-2 py-1 font-bold text-gray-700">Qtd Solicitada</td>
                  <td className="px-2 py-1 text-center">{request?.quantidadeSolicitada}</td>
                </tr>
                <tr className="border-t border-zinc-200 align-middle">
                  <td className="px-2 py-1 font-bold text-gray-700">Qtd Cortada</td>
                  <td className="px-2 py-1 text-center">{request?.quantidadeCortada}</td>
                </tr>
                <tr className="border-t border-zinc-200 align-middle">
                  <td className="px-2 py-1 font-bold text-gray-700">Qtd a Atender</td>
                  <td className="px-2 py-1 text-center">{request?.quantidadeAtender}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* DIV Boleto */}
      { divBoleto &&       
      <div className="flex flex-col py-2 px-4 bg-gray-50 border rounded-md relative">
        <div className="flex flex-row gap-6 w-full whitespace-nowrap">
          <div className="flex items-start gap-1 w-1/2">
            <label className="block text-gray-700 font-bold">
              Identificação Boleto:
            </label>
            <div>{request?.idBoleto}</div>
          </div>
          <div className="flex items-start gap-1 w-full">
            <label className="block text-gray-700 font-bold whitespace-nowrap">
              Tipo Boleto:
            </label>
            <div>{request?.tipoBoleto.toUpperCase()}</div>
          </div>
          <div className="flex items-start gap-1 w-full">
            <label className="block text-gray-700 font-bold whitespace-nowrap">
              Tipo Atendimento:
            </label>
            <div>{request?.tipoAtendimento.toUpperCase()}</div>
          </div>
        </div>
        <div className="flex items-start justify-end gap-1 w-full font-bold">
          <label className="block text-gray-700 font-bold whitespace-nowrap">
            Atender até:
          </label>
          <div>{request?.slaDate ? format(parseISO(request?.slaDate), 'dd/MM/yy HH:mm') : ""}</div>
        </div>
      </div>
      }

      {/* div Site */}
      <div className="flex flex-col gap-2 py-2 px-4 bg-gray-50 border rounded-md relative">
        <div className="flex flex-row gap-8 w-full whitespace-nowrap">
          <div className="flex items-start gap-1">
            <label className="block text-gray-700 font-bold whitespace-nowrap">
              Site:
            </label>
            <div>{request?.site}</div>
          </div>
          <div className="flex items-start gap-1">
            <label className="block text-gray-700 font-bold">
              GMO:
            </label>
            <div>
              {request?.gmo.cidade}
              {request?.gmo.identificador ? (' - '+request.gmo.identificador) : ''}
            </div>
          </div>
          <div className="flex items-start gap-1 w-1/2">
            <label className="block text-gray-700 font-bold">
              DRS Original:
            </label>
            <div>{request?.drsOriginal?.sigla}</div>
          </div>
          <div className="flex items-start gap-1 w-1/2">
            <label className="block text-gray-700 font-bold">
              DRS Atender:
            </label>
            <div>{request?.drsAtender?.sigla ? request?.drsAtender?.sigla : '-'}</div>
          </div>
        </div>
        <div className="flex flex-row gap-8 w-full">
          <div className="flex items-start gap-1 w-full">
            <label className="block text-gray-700 font-bold">
              Endereço GMO:
            </label>
            <div>{request?.gmo.endereco}</div>
          </div>
          <div className="flex items-start gap-1 w-full">
            <label className="block text-gray-700 font-bold">
              Cidade GMO:
            </label>
            <div>{request?.gmo.cidade}</div>
          </div>
        </div>

      </div>

      {/* div Contato */}
      {divContato &&
      <div className="flex flex-col gap-2 py-2 px-4 bg-gray-50 border rounded-md relative">
        <div className="flex flex-row gap-8 w-full">
          <div className="flex items-start gap-1">
            <label className="block text-gray-700 font-bold whitespace-nowrap">
              Técnico:
            </label>
            <div>{request?.tecnico}</div>
          </div>
          <div className="flex items-start gap-1">
            <label className="block text-gray-700 font-bold whitespace-nowrap">
              Telefone:
            </label>
            <div>
              {request?.telefone}
            </div>
          </div>
        </div>
        <div className="flex flex-row gap-8 w-full">
          <div className="flex items-start gap-1 w-fit whitespace-nowrap">
            <label className="block text-gray-700 font-bold ">
              Endereço Entrega:
            </label>
            <div>{request?.enderecoEntrega}</div>
          </div>
          <div className="flex items-start gap-1 w-fit whitespace-nowrap">
            <label className="block text-gray-700 font-bold ">
              Cidade Entrega:
            </label>
            <div>{request?.cidadeEntrega}</div>
          </div>
          <div className="flex items-start gap-1 w-full">
            <label className="block text-gray-700 font-bold whitespace-nowrap">
              Complemento:
            </label>
            <div>{request?.enderecoEntregaComplemento}</div>
          </div>
        </div>
      </div>
      }

      {/* div Recebido */}
      { divRecebido && 
      <div className="flex gap-4 pt-4 px-4 bg-gray-50 border rounded-md relative">

        <div className="flex items-center gap-1 mb-4 w-fit whitespace-nowrap">

          <label className="block text-gray-700 font-bold">
            Recebido Por:
          </label>
          <div>{request?.recebidoPor}</div>

        </div>

        {request?.matriculaRecebedor ?
          <div className="flex items-center gap-1 mb-4 w-fit whitespace-nowrap">
            <label className="block text-gray-700 font-bold">
              Matrícula:
            </label>
            <div>{request?.matriculaRecebedor}</div>
          </div>
          :
          <div className="flex items-center gap-1 mb-4 w-fit whitespace-nowrap">
            <label className="block text-gray-700 font-bold">
              Doc Recebedor:
            </label>
            <div>{request?.docRecebedor}</div>
          </div>
        }
      </div>
      }

      {/* div Carimbo para o Despacho */}
      {carimboDespacho &&
        <div className="flex gap-4 pt-4 px-4 bg-gray-50 border rounded-md relative">

          <div className="flex flex-col items-start gap-1 mb-4 w-full">
            <div className="flex gap-1 text-gray-700">
              <FaStamp />
              <label className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">Carimbo Backoffice:</label>
            </div>
            <div
              className={`w-full px-2 py-1 rounded-lg justify-start items-center inline-flex resize-none text-neutral-600 font-normal`}
            >
              {request?.ultimoCarimbo}
            </div>
          </div>


        </div>
      }

      {isGestao &&

        <div className="flex flex-col px-4 bg-red-100 border rounded-md">
          <div className="flex flex-row gap-2 w-full">
            <div className="flex items-start gap-1 w-full">
              <label className="block text-gray-700 font-bold whitespace-nowrap">Motivo Gestão:</label>
              <div>{request?.motivoEnvioGestao} - {getDescricaoByCod(request?.motivoEnvioGestao)}</div>
            </div>
          </div>
        </div>
      }

    </div>
  )
}
